module.exports = __webpack_public_path__ + "franchise-nav-bar.svg?5d5bba07867b074973717e0eb0ff6d06";